import { FormattedMessage } from "react-intl";

import { ContractFeatures, type IToken } from "@framework/types";
import { Card, Typography } from "@dzambalaorg/ui-kit";

import { TokenGenesisView } from "./genesis";
import { StyledToolbar } from "./styled";

export interface IGenesTokenPanelProps {
  token: IToken;
}

export const GenesTokenPanel = (props: IGenesTokenPanelProps) => {
  const { token } = props;

  if (!token.template?.contract?.contractFeatures.includes(ContractFeatures.GENES)) {
    return null;
  }

  return (
    <Card>
      <Card.Content>
        <StyledToolbar disableGutters>
          <Typography gutterBottom variant="h5" component="p">
            <FormattedMessage id="pages.token.genesis" />
          </Typography>
        </StyledToolbar>
        <TokenGenesisView metadata={token.metadata} />
      </Card.Content>
    </Card>
  );
};
